var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001731",
    d: "M12.59 0c6.618 0 12 5.383 12 12s-5.382 12-12 12c-6.616 0-12-5.383-12-12s5.384-12 12-12m4.17 7H9.42C7.859 7 6.59 8.253 6.59 9.799V13.2C6.59 14.747 7.859 16 9.42 16h7.34c1.564 0 2.83-1.253 2.83-2.799V9.8C19.59 8.253 18.325 7 16.76 7m-4.843 2.28 3.245 2.069c.143.09.118.32-.027.408l-3.222 1.965c-.14.084-.267-.03-.267-.206V9.484c0-.179.13-.292.271-.203"
  })));
};
export default SvgYoutube;